<!--
 * @Description: 申请 审批/办理 意见
 * @Author: peifu
 * @Date: 2022-12-21 15:19:33
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:12:22
-->
<template>
  <div>
    <el-dialog class="w500 h400" :model-value="isYiJian" :title="row.title" :before-close="handleClose" :close-on-click-modal="false" destroy-on-close>
      <el-input class="mt10" v-model="yj" :rows="8" type="textarea" :placeholder="'请输入'+row.title" resize="none"/>
      <template #footer>
        <div style="flex: auto">
          <el-button type="primary" :loading="qdLoading" @click="quedingClick">确定</el-button>
          <el-button @click="handleClose">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits } from 'vue'
import { liuzhuanbuzhou } from '@/api/home.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
const props = defineProps({
  isYiJian: { type: Boolean, required: true },
  row: { type: Object, required: false}
})
const emits = defineEmits(['update:isYiJian', 'yiJianReturn'])


const yj = ref()
const row = ref()
const qdLoading = ref(false)

const quedingClick = () => {
  switch (row.value.type) {
    case 1:
      tongYiClick()
      break
    case 2:
      juJueClick()
      break
  }
}
// 审批 同意
const tongYiClick = () => {
  const obj = {
    splzbzID: row.value.ryid,
    zt: 9, // 状态：0-未开始，1-审批中，3-办理中，9-通过/办理，10-拒绝
    yj: yj.value // 办理意见
  }
  qdLoading.value = true
  liuzhuanbuzhou(obj).then((res) => {
    yj.value = ''
    if (res.code === 200) {
      handleClose()
      emits('yiJianReturn')
      successPrompt(res.message)
      qdLoading.value = false
    } else {
      qdLoading.value = false
      warningPrompt(res.message)
    }
  })
}
// 审批 拒绝
const juJueClick = () => {
  const obj = {
    splzbzID: row.value.ryid,
    zt: 10, // 状态：0-未开始，1-审批中，3-办理中，9-通过，10-拒绝
    yj: yj.value // 办理意见
  }
  qdLoading.value = true
  liuzhuanbuzhou(obj).then((res) => {
    if (res.code === 200) {
      handleClose()
      emits('yiJianReturn')
      successPrompt(res.message)
      qdLoading.value = false
    } else {
      qdLoading.value = false
      warningPrompt(res.message)
    }
  })
}
// 关闭
const handleClose = () => {
  yj.value = ''
  emits('update:isYiJian', false)
}
watch(
  () => props.isYiJian,
  () => {
    if (props.isYiJian) {
      row.value = props.row
    }
  },
  { deep: true, immediate: true }
)
</script>
